<mat-chip-listbox [(ngModel)]="value" (click)="valueChange.emit(value)">
  <mat-chip-option *ngFor="let result of resultList" [value]="result.id">{{result.displayName}}</mat-chip-option>
</mat-chip-listbox>
